import { forwardRef } from "react"
import { mergeClasses } from "@lib/css"

import type { IconProps } from "./types"

export const IconSubstack = forwardRef<SVGSVGElement, IconProps>(
  function IconSubstack(props, ref) {
    const { className, title, titleId, ...otherProps } = props
    const defaultClasses =
      "w-8 h-8 flex-shrink-0 transition-colors duration-150 ease-in focus:outline-none"
    const classes = mergeClasses(defaultClasses, className)
    const fillColor = props.fill || "currentColor"

    return (
      <svg
        ref={ref}
        viewBox="0 0 32 32"
        fill="none"
        focusable="false"
        aria-hidden="true"
        tabIndex={-1}
        className={classes}
        aria-labelledby={titleId}
        {...otherProps}
      >
        {title ? <title id={titleId}>{title}</title> : null}
        <path
          d="M24.5208 5.14008L9.90078 1.23008L9.65078 1.16008C6.75078 0.380085 3.89078 2.57008 3.89078 5.58008V22.4501C3.89078 24.5201 5.28078 26.3301 7.28078 26.8701L22.1408 30.8501C25.0408 31.6301 27.9008 29.4401 27.9008 26.4301V9.56009C27.9008 7.49009 26.5108 5.68008 24.5108 5.14008H24.5208Z"
          fill="none"
        />
        <path
          d="M23.3408 31.6001C22.8908 31.6001 22.4408 31.5401 21.9908 31.4201L7.13078 27.4401C4.87078 26.8401 3.30078 24.7801 3.30078 22.4401V5.58008C3.30078 3.96008 4.04078 2.46008 5.32078 1.48008C6.61078 0.490085 8.24078 0.170085 9.81078 0.590085L24.6708 4.57009C26.9308 5.17008 28.5008 7.23008 28.5008 9.57008V26.4401C28.5008 28.0601 27.7608 29.5601 26.4808 30.5401C25.5608 31.2501 24.4708 31.6101 23.3408 31.6101V31.6001ZM8.46078 1.60008C7.60078 1.60008 6.76078 1.88008 6.05078 2.42008C5.06078 3.18008 4.50078 4.33009 4.50078 5.57009V22.4401C4.50078 24.2301 5.71078 25.8101 7.44078 26.2801L22.3008 30.2601C23.5008 30.5801 24.7608 30.3301 25.7508 29.5701C26.7408 28.8101 27.3008 27.6601 27.3008 26.4201V9.56009C27.3008 7.77009 26.0908 6.19008 24.3508 5.72008L9.50078 1.74008C9.16078 1.65008 8.81078 1.60008 8.46078 1.60008Z"
          fill={fillColor}
        />
        <path
          d="M21.9008 25.8101C21.7608 25.8101 21.6308 25.7601 21.5208 25.6701L15.7708 20.8801L10.0808 22.5801C9.90078 22.6301 9.70078 22.6001 9.55078 22.4901C9.40078 22.3801 9.31078 22.2001 9.31078 22.0101V13.0101C9.31078 12.8201 9.40078 12.6501 9.54078 12.5301C9.69078 12.4101 9.88078 12.3701 10.0608 12.4301L22.0608 15.6401C22.3208 15.7101 22.5008 15.9501 22.5008 16.2201V25.2201C22.5008 25.4501 22.3708 25.6601 22.1508 25.7601C22.0708 25.8001 21.9808 25.8201 21.9008 25.8201V25.8101ZM15.9008 19.6101C16.0408 19.6101 16.1708 19.6601 16.2808 19.7501L21.3008 23.9301V16.6701L10.5008 13.7801V21.1901L15.7308 19.6301C15.7908 19.6101 15.8408 19.6101 15.9008 19.6101Z"
          fill={fillColor}
        />
        <path
          d="M21.9008 13.8301C21.8508 13.8301 21.8008 13.8301 21.7408 13.8101L9.74078 10.5901C9.42078 10.5001 9.23078 10.1701 9.32078 9.86008C9.41078 9.54008 9.74078 9.35008 10.0608 9.44008L22.0608 12.6601C22.3808 12.7501 22.5708 13.0801 22.4808 13.3901C22.4108 13.6601 22.1708 13.8401 21.9008 13.8401V13.8301Z"
          fill={fillColor}
        />
        <path
          d="M21.9008 10.8201C21.8508 10.8201 21.8008 10.8201 21.7408 10.8001L9.74078 7.58008C9.42078 7.50008 9.23078 7.17008 9.32078 6.85008C9.41078 6.53008 9.74078 6.34008 10.0508 6.43008L22.0508 9.65008C22.3708 9.73008 22.5608 10.0601 22.4708 10.3801C22.4008 10.6501 22.1608 10.8301 21.8908 10.8301L21.9008 10.8201Z"
          fill={fillColor}
        />
      </svg>
    )
  },
)
